import TextareaAutosize from 'react-textarea-autosize'
import React from 'react'
import PropTypes from 'prop-types'
import RecipientDropdown from './RecipientDropdown'
import { Button } from 'antd'
import CustomTextareaAutosize from '../components/CustomTextareaAutosize/CustomTextareaAutosize'
import { useFlags } from 'launchdarkly-react-client-sdk'
import TemplateSuggestion from '@app/common/components/TemplateSuggestion'


function onKeyPress(e, onSubmit) {
  if (e.key === 'Enter') {
    e.preventDefault()
    onSubmit(null)
  }
}

export default function NewMessageTem({
  isSubmitting = false,
  onFocus,
  newMessageValue,
  handleInputChange,
  newMessageTitle,
  onSubmit,
  userCanApproveMessage,
  userCanChooseRecipient,
  handleRecipientChange,
  recipient,
  conversationCompany,
  selectedTemplate,
  templates = [],
  audienceFilter,
  onTemplateSelect,
  onViewAllTemplates,
  isUnifiedConversation,
  isTemplateSuggestionEnabled,
}) {
  /**
  NewMessageTem component renders UI for creating a message for Unified Conversations.

  NewMessageTem is the equivalent of NewMessage.

  This UI includes a text area for the user to input a message body, a dropdown to select the intended recipient, and a Send button.
  */
  const flags = useFlags() || {}

  const onSubmitWrapper = () => {
    if (userCanChooseRecipient && !selectedTemplate && !recipient) {
      // extra protection to prevent sending message to Unified Conversation without selecting a recipient
      return
    }
    const isUnifiedConversation = true
    onSubmit({
      userCanApproveMessage,
      isUnifiedConversation,
      userCanChooseRecipient,
      selectedTemplate,
    })
  }

  const disableSubmit = newMessageValue === '' || (userCanChooseRecipient && !selectedTemplate && !recipient)
  return (
    <main className='send-message' id='new-message-tem'>
      <div className='w-100 mr-2'>
        {flags?.useUpdatedMessageTemplatesUx
          ? <TemplateSuggestion
            templates={templates}
            onTemplateSelect={onTemplateSelect}
            onViewAllTemplates={onViewAllTemplates}
            audienceFilter={audienceFilter}
            minCharacters={3}
            maxVisibleSuggestions={4}
            inputValue={newMessageValue}
            selectedTemplate={selectedTemplate}
            showPreApprovedOnly
            isUnifiedConversation={isUnifiedConversation}
            isEnabled={isTemplateSuggestionEnabled}
          >
            <CustomTextareaAutosize
              type='text'
              onKeyPress={(e) => onKeyPress(e, onSubmitWrapper)}
              onFocus={onFocus}
              value={newMessageValue}
              onChange={handleInputChange}
              className="form-control"
              placeholder="Type your message..."
              title={newMessageTitle}
              disabled={selectedTemplate?.is_pre_approved && !userCanApproveMessage}
              clearable
            />
          </TemplateSuggestion>
          : <TextareaAutosize
            type='text'
            onKeyPress={(e) => onKeyPress(e, onSubmitWrapper)}
            onFocus={onFocus}
            value={newMessageValue}
            onChange={handleInputChange}
            className="form-control"
            placeholder="Type your message..."
            title={newMessageTitle}
          />
        }
      </div>
      <div className='d-flex align-items-center'>
        {userCanChooseRecipient && (
          <RecipientDropdown
            userCanApproveMessage={userCanApproveMessage}
            handleRecipientChange={handleRecipientChange}
            recipient={recipient}
            onFocus={onFocus}
            conversationCompany={conversationCompany}
            containerClassName="recipient-dropdown-container"
          />
        )}
        <Button
          data-testid="send-message-button"
          onClick={onSubmitWrapper}
          disabled={disableSubmit}
          loading={isSubmitting}
          type="primary"
        >
            Send
        </Button>
      </div>
    </main>)
}


NewMessageTem.propTypes = {
  conversationCompany: PropTypes.string,
  handleInputChange: PropTypes.func,
  handleRecipientChange: PropTypes.func,
  isSubmitting: PropTypes.bool,
  newMessageTitle: PropTypes.string,
  newMessageValue: PropTypes.string,
  onFocus: PropTypes.func,
  onSubmit: PropTypes.func,
  recipientValue: PropTypes.string,
  userCanApproveMessage: PropTypes.bool,
  userCanChooseRecipient: PropTypes.bool,
}
